import styled from 'styled-components';

export const SecondaryButtonContainer = styled.button`
  border-radius: 8px;
  border: none;
  background: var(--grey);
  color: var(--grey7);
  font-weight: 600;
  padding: 0.8rem 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  font-weight: 600 !important;
  letter-spacing: 0.1rem !important;
  text-transform: uppercase !important;
  font-style: normal !important;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.grey6};
  &:hover {
    background: ${({ theme }) => theme.colors.grey7};
    color: ${({ theme }) => theme.colors.grey};
    transform: scale(1.08);
  }
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.xl};
  font-weight: bold;
  transform: ${({ active }) => (active ? 'scale(1.08)' : 'scale(1)')};
  transition:
    background 0.2s,
    color 0.2s,
    transform 0.2s;
`;
